import { render } from "./routerCom.vue?vue&type=template&id=04b1c64e&scoped=true"
import script from "./routerCom.vue?vue&type=script&lang=js"
export * from "./routerCom.vue?vue&type=script&lang=js"

import "./routerCom.vue?vue&type=style&index=0&id=04b1c64e&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b1c64e"]])

export default __exports__